<template>
  <section class="about-leader">
    <div class="about-leader-container">
      <div class="about-leader-content">
        <div class="about-leader-text">
          <h2 class="about-leader-title">{{ title }}</h2>
          <div>
            <p v-if="!isExpanded"
               class="about-leader-body">
              {{ truncatedText }}
            </p>
            <template v-else>
              <p v-for="(p, i) in paragraphs"
                 :key="i"
                 class="about-leader-body">
                {{ p }}
              </p>
            </template>
            <div class="pt-8">
              <button
                class="about-leader-link"
                @click="userExpanded = !userExpanded">
                {{ userExpanded ? showLessText : readMoreText }}
              </button>
            </div>
          </div>

        </div>
        <div class="about-leader-side">
          <img :src="image"
               :alt="leaderName"
               class="about-leader-image">
               <p class="about-leader-name vs">{{ leaderName }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()
const title = computed(() => t('about.leader.title'))
const paragraphs = computed(() => [
  t('about.leader.paragraph1'),
  t('about.leader.paragraph2'),
  t('about.leader.paragraph3')
])
const readMoreText = computed(() => t('about.leader.readMore'))
const showLessText = computed(() => t('about.leader.showLess'))
const leaderName = computed(() => t('about.leader.leaderName'))
const image = '/assets/images/about/leader-vershylo.png'

const TRUNCATE_AT = 350

const allText = computed(() => paragraphs.value.join(' '))
const truncatedText = computed(() => allText.value.slice(0, TRUNCATE_AT) + '...')

const isMobile = ref(false)
const userExpanded = ref(false)
const isExpanded = computed(() => !isMobile.value || userExpanded.value)

onMounted(() => {
  const mq = window.matchMedia('(max-width: 767px)')
  isMobile.value = mq.matches
  mq.addEventListener('change', (e) => { isMobile.value = e.matches })
})
</script>

<style scoped>
/* Фон на всю ширину; дві колонки на повну висоту, падінги налаштовуються окремо */
.about-leader {
  width: 100%;
  background: linear-gradient(90deg, rgba(252, 243, 224, 0.3) 0%, rgba(210, 235, 240, 0.3) 100%);
  --col-text-padding: 80px 40px 80px 60px;
  --col-image-padding: 80px 60px 0 40px;
}

.about-leader-container {
  overflow: hidden;
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
}

.about-leader-content {
  display: grid;
  grid-template-columns: 1fr 40%;
  min-height: 776px;
  align-items: stretch;
  gap: 30px;
}

/* Колонка тексту — на всю висоту, падінги змінні */
.about-leader-text {
  padding-top: 135px;
}

.about-leader-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 42px;
  line-height: 1.3;
  color: var(--color-dark-blue);
  padding-bottom: 20px;
  margin: 0 0 8px 0;
}

.about-leader-body {
  font-family: var(--font-inter);
  font-size: var(--font-size-body);
  line-height: 2;
  color: var(--color-dark-blue);
  margin: 0;
}

.about-leader-link {
  font-family: var(--font-inter);
  font-size: var(--font-size-body);
  color: var(--color-grey);
  text-decoration: underline;
  margin-top: 8px;
  transition: color 0.2s;
  display: inline;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.about-leader-link:hover {
  color: var(--color-teal);
}

/* Колонка картинки — на всю висоту, падінги змінні */
.about-leader-side {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  padding-top: 70px;
  min-height: 0;
  position: relative;
}

.about-leader-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  position: relative;
  top: 5px;
  max-width: 500px;
}

.about-leader-name {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: var(--font-size-body);
  color: var(--color-black);
  margin: 0;
  text-align: right;
  /* margin-top: 16px; */
}

@media (max-width: 1400px) {
  .about-leader-container {
    padding: 0 60px;
  }
  .about-leader {
    --col-text-padding: 80px 60px 80px 60px;
    --col-image-padding: 80px 60px 0 60px;
  }
}

@media (max-width: 991px) {
  .about-leader-container {
    padding: 0 30px;
  }
  .about-leader-content {
    grid-template-columns: 1fr;
    gap: 0;
    min-height: 0;
  }

  .about-leader {
    --col-text-padding: 60px 30px 40px 30px;
    --col-image-padding: 0 30px 0 30px;
  }

  .about-leader-side {
    align-items: center;
  }

  .about-leader-name {
    text-align: center;
  }
}

@media (max-width: 767px) {
  .about-leader-container {
    padding: 0 20px;
  }
  .about-leader {
    --col-text-padding: 40px 20px 32px 20px;
    --col-image-padding: 0 20px 0 20px;
  }

  .about-leader-title {
    font-size: var(--font-size-title);
  }

  .about-leader-body {
    font-size: var(--font-size-body);
  }
  .about-leader-text {
    padding-top: 35px;
  }


}

@media (min-width: 768px) {
  /* На десктопі кнопка прихована, весь текст показується */
  .about-leader-link {
    display: none;
  }
}

.about-leader-name.vs{
  color: #fff;
  position: absolute;
  bottom: 5%;
  right: 25%;
}
</style>
